import { useCallback, useEffect, useRef, useState } from "react";

export const useElementHeight = () => {
  const elementRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState(400);

  const updateHeight = useCallback(() => {
    if (elementRef.current) {
      const elementHeight = elementRef.current.offsetHeight;
      setHeight(elementHeight);
    }
  }, []);

  useEffect(() => {
    updateHeight();

    window.addEventListener("resize", updateHeight);

    const timer = setTimeout(updateHeight, 500);

    return () => {
      window.removeEventListener("resize", updateHeight);
      clearTimeout(timer);
    };
  }, [updateHeight]);

  return { elementRef, height, updateHeight };
};
